module.exports = __webpack_public_path__ + "img/hero-home.b4fc3648.jpg";